/*=============================================== OverlayPage ===============================================*/

import { CardColor, ComponentsLayout } from "components"

import { allOverlays } from "data"

const OverlayPage = () => {
    return (
        <ComponentsLayout>
            {allOverlays.map(overlay => (
                <CardColor overlay={overlay} key={overlay.css} />
            ))}
        </ComponentsLayout>
    )
}

export default OverlayPage
